const PLACEHOLDER =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";

const join = (base, path) =>
  `${String(base || "").replace(/\/$/, "")}/${String(path || "").replace(/^\//, "")}`;

export default function getAvatarUrl(value) {
  if (!value) return PLACEHOLDER;
  if (typeof value !== "string") return PLACEHOLDER;
  if (/^https?:\/\//i.test(value)) return value;

  // si ton file server est exposé :
  const FILE_BASE = import.meta.env.VITE_FILE_BASE_URL || "";
  if (FILE_BASE) return join(FILE_BASE, value);

  const gateway = import.meta.env.VITE_GATEWAY_URL || window.location.origin;
  return join(gateway, value);
}